import {UserSessionService} from "../services/user-session/user-session.service";

export function userSessionStarterFactory(provider: UserSessionService) {
	return () => provider.startSessionOnApplicationBootstrap();
}
